import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const userTimeZone = dayjs.tz.guess();

export { dayjs, userTimeZone };
